(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      document.body.style.setProperty("--header-height", this.header.offsetHeight + "px")
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    if(productInfoWrapper){
      const productVariationTitle = productInfoWrapper.querySelector('.product-variations__title');
      const productVariationTitleHover = productInfoWrapper.querySelector('.product-variations__title-hover');
      const productVariations = productInfoWrapper.querySelectorAll('.product-variations__item');
      productVariations.forEach(function(variation) {
        if (!variation.classList.contains('active')) {
          variation.addEventListener('mouseover', function() {
            productVariationTitleHover.textContent = variation.dataset.title;
            productVariationTitleHover.classList.remove('hidden');
          });
          variation.addEventListener('mouseout', function() {
            productVariationTitleHover.classList.add('hidden');
            productVariationTitleHover.textContent = '';
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');

              //Create slider
              console.log("Let's create the slider")
              // var swiperHSS = new Swiper(".product-recommendations__slider", {
              //     loop: true,
              //     pagination: true,
              //     slidesPerView: 4,
              //     speed: 1000,
              // });

              console.log(this.querySelector('.product-recommendations__slider'))
              var event = new CustomEvent('sliderLoaded');
              document.dispatchEvent(event);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-sub-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(el) {
      if (!el || el.getAttribute('data-flickity-initialized') === 'true') return;
      if (typeof Flickity === 'undefined') return;
      var optionsJson = el.getAttribute('data-flickity-options');
      var options = { cellSelector: '.shpflt-sub-categories__item' };
      if (optionsJson) {
        try {
          options = Object.assign({}, JSON.parse(optionsJson), options);
        } catch (e) {}
      }
      var flkty = new Flickity(el, options);
      el.setAttribute('data-flickity-initialized', 'true');
      el.flickityInstance = flkty;
      var activeCell = el.querySelector('.shpflt-sub-categories__item.is-active');
      if (activeCell && flkty) {
        var cells = el.querySelectorAll('.shpflt-sub-categories__item');
        var index = Array.prototype.indexOf.call(cells, activeCell);
        if (index > 0) {
          flkty.select(index, false, true);
        }
      }
    }

    function destroySlider(el) {
      if (!el || !el.flickityInstance) return;
      el.flickityInstance.destroy();
      el.flickityInstance = null;
      el.removeAttribute('data-flickity-initialized');
    }

    function initAll() {
      var sliders = document.querySelectorAll('.shpflt-sub-categories__slider');
      sliders.forEach(initSlider);
    }

    function initOnLoad() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
      } else {
        initAll();
      }
      window.addEventListener('load', initAll);
    }
    initOnLoad();

    document.addEventListener('shopify:section:load', function (event) {
      var sectionEl = document.getElementById('shpflt-sub-categories-' + event.detail.sectionId);
      if (sectionEl) {
        var slider = sectionEl.querySelector('.shpflt-sub-categories__slider');
        if (slider) initSlider(slider);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var sectionEl = document.getElementById('shpflt-sub-categories-' + event.detail.sectionId);
      if (sectionEl) {
        var slider = sectionEl.querySelector('.shpflt-sub-categories__slider');
        if (slider) destroySlider(slider);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-total-look"] && !Shopify.designMode) return;
  try {
    
  (function() {
    try {
      var params = new URLSearchParams(window.location.search);
      var lookParam = params.get('look');
      if (!lookParam) return;

      var lookNum = parseInt(lookParam, 10);
      if (isNaN(lookNum) || lookNum < 1) return;

      var target = document.getElementById('look-' + lookNum);

      var headerHeight = 0;
      try {
        var varVal = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (varVal) {
          headerHeight = parseInt(varVal.replace('px', '').trim(), 10) || 0;
        }
      } catch (e) {}

      var extraOffset = 100;

      var scrollToTarget = function() {
        if (!target) return;
        var rect = target.getBoundingClientRect();
        var absoluteTop = window.pageYOffset + rect.top;
        var y = Math.max(absoluteTop - headerHeight - extraOffset, 0);
        try {
          window.scrollTo(0, y);
        } catch (e) {
          window.scrollTo({ top: y });
        }

        // Move focus for accessibility so screen readers announce the section
        try { target.focus({ preventScroll: true }); } catch(e) {}

        // Remove the `look` param without reloading, keep other params and hash
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('look');
          var newSearch = url.searchParams.toString();
          var newUrl = url.pathname + (newSearch ? '?' + newSearch : '') + (url.hash || '');
          window.history.replaceState({}, document.title, newUrl);
        } catch (e) {}
      };

      var attemptImmediate = function() {
        if (target) {
          requestAnimationFrame(scrollToTarget);
          return true;
        }
        return false;
      };

      if (!attemptImmediate()) {
        var container = document.getElementById('shpflt-total-look');
        if (container && 'MutationObserver' in window) {
          var mo = new MutationObserver(function() {
            target = document.getElementById('look-' + lookNum);
            if (attemptImmediate()) { mo.disconnect(); }
          });
          mo.observe(container, { childList: true, subtree: true });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
            target = document.getElementById('look-' + lookNum);
            attemptImmediate();
          }, { once: true });
        }
      }
    } catch (e) {
      // no-op
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
